import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, Close } from '@mui/icons-material';
import ThemeToggle from '../shared/ThemeToggle';

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const closeMobileMenu = () => setIsMobileMenuOpen(false);
    const toggleMobileMenu = () => setIsMobileMenuOpen(prev => !prev);

    const linkBaseClasses =
        'font-medium transition-all duration-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 dark:focus:ring-offset-slate-900 whitespace-nowrap';

    return (
        <>
            <nav className="bg-white/90 backdrop-blur-md border-b border-amber-200/50 sticky top-0 z-50 shadow-sm dark:border-slate-700/80 dark:bg-slate-900/95">
                <div className="w-full mx-auto px-6 sm:px-8 lg:px-12">
                    <div className="grid grid-cols-12 items-center h-16 gap-4">

                        {/* Logo */}
                        <div className="col-span-7 xl:col-span-3 flex items-center space-x-3 min-w-0">
                            <div className="w-8 h-8 bg-gradient-to-r from-amber-500 to-yellow-600 rounded-lg shadow-md flex items-center justify-center">
                                <span className="text-white font-bold text-sm">N</span>
                            </div>

                            <NavLink
                                to="/"
                                onClick={closeMobileMenu}
                                className="flex items-center space-x-2 min-w-0"
                            >
                                <span className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-amber-600 to-yellow-700 bg-clip-text text-transparent dark:from-amber-400 dark:to-yellow-400">
                                    Netikash
                                </span>
                                <span className="text-amber-700 font-medium bg-amber-100 px-2 py-1 rounded-md text-sm dark:bg-amber-500/10 dark:text-amber-300 hidden sm:inline-flex">
                                    Developer
                                </span>
                            </NavLink>
                        </div>

                        {/* Desktop Navigation */}
                        <div className="hidden xl:flex items-center justify-center col-span-6 gap-3">
                            <NavLink
                                to="/documentation"
                                className={({ isActive }) =>
                                    `${linkBaseClasses} px-4 py-2 ${
                                        isActive
                                            ? 'text-amber-700 bg-amber-100 shadow-inner dark:bg-amber-500/15 dark:text-amber-300'
                                            : 'text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400'
                                    }`
                                }
                            >
                                Documentation
                            </NavLink>

                            <NavLink
                                to="/integration"
                                className={({ isActive }) =>
                                    `${linkBaseClasses} px-4 py-2 ${
                                        isActive
                                            ? 'text-amber-700 bg-amber-100 shadow-inner dark:bg-amber-500/15 dark:text-amber-300'
                                            : 'text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400'
                                    }`
                                }
                            >
                                Intégration
                            </NavLink>

                            <NavLink
                                to="/examples"
                                className={({ isActive }) =>
                                    `${linkBaseClasses} px-4 py-2 ${
                                        isActive
                                            ? 'text-amber-700 bg-amber-100 shadow-inner dark:bg-amber-500/15 dark:text-amber-300'
                                            : 'text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400'
                                    }`
                                }
                            >
                                Exemples
                            </NavLink>

                            <NavLink
                                to="/plugins"
                                className={({ isActive }) =>
                                    `${linkBaseClasses} px-4 py-2 ${
                                        isActive
                                            ? 'text-amber-700 bg-amber-100 shadow-inner dark:bg-amber-500/15 dark:text-amber-300'
                                            : 'text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400'
                                    }`
                                }
                            >
                                Plugins
                            </NavLink>

                            <NavLink
                                to="/assistant"
                                className={({ isActive }) =>
                                    `${linkBaseClasses} px-4 py-2 ${
                                        isActive
                                            ? 'text-amber-700 bg-amber-100 shadow-inner dark:bg-amber-500/15 dark:text-amber-300'
                                            : 'text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400'
                                    }`
                                }
                            >
                                Assistant IA
                            </NavLink>

                            {/* 🔗 Contact — lien externe */}
                            <a
                                href="https://akiba.netikash.com/contact"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={`${linkBaseClasses} px-4 py-2 text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400`}
                            >
                                Contact
                            </a>
                        </div>

                        {/* Right Side */}
                        <div className="col-span-5 xl:col-span-3 flex items-center justify-end space-x-2 sm:space-x-3 min-w-0">
                            <ThemeToggle />

                            <a
                                href="https://gateway.netikash.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-gradient-to-r from-amber-500 to-yellow-600 text-white px-3 sm:px-5 py-2 rounded-lg font-medium hover:from-amber-600 hover:to-yellow-700 transition-all transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl border border-amber-400/30 flex items-center space-x-2 group text-sm sm:text-base whitespace-nowrap"
                            >
                                <span>Commencer</span>
                                <svg
                                    className="w-3 h-3 sm:w-4 sm:h-4 group-hover:translate-x-1 transition-transform"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                                </svg>
                            </a>

                            <button
                                onClick={toggleMobileMenu}
                                aria-label="Menu mobile"
                                aria-expanded={isMobileMenuOpen}
                                className="xl:hidden p-2 rounded-lg text-gray-700 hover:text-amber-600 hover:bg-amber-50 transition-colors focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400 dark:focus:ring-offset-slate-900"
                            >
                                {isMobileMenuOpen ? <Close /> : <Menu />}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Mobile Menu */}
                {isMobileMenuOpen && (
                    <div className="xl:hidden bg-white border-t border-amber-200/50 shadow-lg dark:border-slate-700/80 dark:bg-slate-900">
                        <div className="px-4 py-6 space-y-4">
                            <NavLink to="/documentation" onClick={closeMobileMenu} className="block px-4 py-3 rounded-lg font-medium text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400">
                                Documentation
                            </NavLink>
                            <NavLink to="/integration" onClick={closeMobileMenu} className="block px-4 py-3 rounded-lg font-medium text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400">
                                Intégration
                            </NavLink>
                            <NavLink to="/examples" onClick={closeMobileMenu} className="block px-4 py-3 rounded-lg font-medium text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400">
                                Exemples
                            </NavLink>
                            <NavLink to="/plugins" onClick={closeMobileMenu} className="block px-4 py-3 rounded-lg font-medium text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400">
                                Plugins
                            </NavLink>
                            <NavLink to="/assistant" onClick={closeMobileMenu} className="block px-4 py-3 rounded-lg font-medium text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400">
                                Assistant IA
                            </NavLink>

                            {/* 🔗 Contact — lien externe */}
                            <a
                                href="https://akiba.netikash.com/contact"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={closeMobileMenu}
                                className="block px-4 py-3 rounded-lg font-medium text-gray-700 hover:text-amber-600 hover:bg-amber-50 dark:text-slate-200 dark:hover:bg-slate-800 dark:hover:text-amber-400"
                            >
                                Contact
                            </a>

                        </div>
                    </div>
                )}
            </nav>

            {/* Overlay */}
            {isMobileMenuOpen && (
                <div
                    className="fixed inset-0 bg-black/20 z-40 xl:hidden"
                    onClick={closeMobileMenu}
                />
            )}
        </>
    );
};

export default Navbar;
